<template>
  <button :class="$style.wrapper" @click="setActiveState">
    <IconSelect
      v-show="!drawerIsVisible"
      :class="$style['menu-icon']"
      icon="menu"
      height="44"
      width="44"
    />
    <IconSelect
      v-show="drawerIsVisible"
      :class="$style['menu-icon']"
      icon="close"
      height="44"
      width="44"
    />

    <span :class="$style.title">{{ $t('navigation.menu') }}</span>
  </button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'

import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'MenuButton',
  components: {
    IconSelect,
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      drawerIsVisible: APP_GETTERS.NAVIGATION_DRAWER_VISIBILITY,
    }),
  },
  methods: {
    ...mapActions(STOREMODULES.APP, {
      showDrawer: APP_ACTIONS.SHOW_NAVIGATION_DRAWER,
      hideDrawer: APP_ACTIONS.HIDE_NAVIGATION_DRAWER,
    }),
    setActiveState() {
      if (this[APP_CONSTANTS.DRAWER_IS_VISIBLE]) {
        this.hideDrawer()
      } else {
        this.showDrawer()
      }
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;
  margin-right: 1.25rem;

  outline: 0 none;

  cursor: pointer;

  pointer-events: all;
}

.menu-icon {
  color: var(--black);
}

.title {
  margin-left: 0.375rem;

  font-weight: var(--font-weight-bold);
  line-height: 1;
  text-transform: uppercase;
}
</style>
